import type { Subscription } from '../types/subscription';
import SubscriptionType, {
  HOSTING_PAID_TYPES,
  ECOMMERCE_PAID_TYPES,
} from '../constants/subscription-type';

const PAID_TYPES = [
  ...HOSTING_PAID_TYPES,
  ...ECOMMERCE_PAID_TYPES,
  SubscriptionType.DOMAIN_SUBSCRIPTION,
];

function hasRenewablePaidSubscription(subscriptions: Subscription[]): boolean {
  return subscriptions.some(
    (subscription: Subscription) =>
      PAID_TYPES.some((paidType) => paidType === subscription.type) && subscription.auto_renew
  );
}

export default hasRenewablePaidSubscription;
